import React from 'react';
import {Button} from "./Button";

export class ButtonGroup extends React.Component {

  render(){

    const buttons = this.props.data.map( ( button, index ) => {
      return (
        <Button key={index}
                shape="block"
                type="button"
                role={"button"}
                onClick={() => this.props.selected(button)}
                className={(this.props.isSelected(this.props.selected_button, button.id) ? "selected" : "" ) + " button-group-button"}>
          { button.name }
        </Button>
      );
    });

    return (
      <div className="button-group-container">
        { buttons }
      </div>
    );
  }
}

ButtonGroup.defaultProps = {
  item: 'SimpleItem'
};



// WEBPACK FOOTER //
// ./src/components/button/ButtonGroup.js